import MainRoleManagment from "../components/role-managment/main-role";

function RoleManagment() {
  return (
    <div className="w-[97%] mx-auto">
        
      <MainRoleManagment />
    </div>
  );
}

export default RoleManagment;
